module.exports = "module.exports = __webpack_public_path__ + \"static/media/book.bf491ffe.yaml\";";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/content/book.yaml
// module id = 1350
// module chunks = 0